export const FNOL_UPLOAD = () => {
  return {
    list: {
      "listData": {
        "supportDocsList": [
          {
            "heading": $localize`:@@documents.travelClaim:Required for Travel Claims: `,
            "docDetails": [
              {
                "label": "",
                "docs": {
                  "config": {
                    "kind": "icon"
                  },
                  "list": [
                  ]
                }
              },
              {
                "label": $localize`:@@documents.paRequiredDoc:Depending on the type of claim, required documents may include copies of the following:`,
                "docs": {
                  "config": {
                    "kind": "icon"
                  },
                  "list": [
                    {
                      "icon": "check_circle",
                      "name": $localize`:@@documents.proofOfTravel:Proof of Travel – Passport, travel itinerary, or rental agreements.`
                    },
                    {
                      "icon": "check_circle",
                      "name": $localize`:@@documents.proofOfExpense:Proof of Expenses – Original receipts, invoices, or bank statements for costs related to medical treatment, accommodation, transport, rental vehicles, or replacement documents.`
                    },
                    {
                      "icon": "check_circle",
                      "name": $localize`:@@documents.officialReport:Official Reports – Police reports for lost or stolen items, airline letters for delays or losses, and third-party claim documents such as letters of demand or quotations. `
                    },
                    {
                      "icon": "check_circle",
                      "name": $localize`:@@documents.medicalDocument:Medical and Supporting Documents – Medical reports, doctor’s memos, discharge summaries, proof of relationship, or a death certificate.`
                    }
                  ]
                }
              }

            ]
          }
        ],
        "supportDocsListPA": [
          {
            "heading": $localize`:@@documents.personalAccident:Required for Personal Accident & Illness Claims:`,
            "docDetails": [
              {
                "label": "",

                "docs": {
                  "config": {
                    "kind": "icon"
                  },
                  "list": [
                  ]
                }
              },
              {
                "label": $localize`:@@documents.paRequiredDoc:Depending on the type of claim, required documents may include copies of the following:`,
                "docs": {
                  "config": {
                    "kind": "icon"
                  },
                  "list": [
                    {
                      "icon": "check_circle",
                      "name": $localize`:@@documents.paMedicalBill:Medical Bills and Receipts – For any medical expenses incurred.`
                    },
                    {
                      "icon": "check_circle",
                      "name": $localize`:@@documents.paMedicalDoc:Medical Documentation – Medical reports, doctor’s memos, inpatient discharge summaries, or any relevant documentation confirming treatment and or medical leave.`
                    },
                    {
                      "icon": "check_circle",
                      "name": $localize`:@@documents.paPoliceReport:Police Reports – Required for claims involving traffic accidents.`
                    },
                    {
                      "icon": "check_circle",
                      "name": $localize`:@@documents.paDeathCertificate:Copy of Death Certificate, Postmortem or Toxicology Reports – Required for claims involving accidental death.`
                    }
                  ]
                }
              },
              {
                "label": ""
              }
            ]
          }
        ],
        "supportedListOther": [
          {
            "heading": $localize`:@@documents.requiredDocuments:Required Documents:`,
            "docDetails": [
              {
                "label": ""
              }
            ]
          }
        ]
      },
      "be": {
        "supportDocsList": [
          {
            "heading": $localize`:@@documents.travelClaim:Required for Travel Claims: `,
            "docDetails": [

            ]
          }
        ],
        "supportDocsListPA": [
          {
            "heading": $localize`:@@documents.personalAccident:Required for Personal Accident & Illness Claims:`,
            "docDetails": [
            ]
          }
        ],
        "supportedListOther": [
          {
            "heading": $localize`:@@documents.requiredDocuments:Required Documents:`,
            "docDetails": [
              {
                "label": ""
              }
            ]
          }
        ]
      }
    }
  }
};

export const alertVisible = {
  be: true
}
